import { addClassToElement, removeClassFromElement } from './utils';

const addClassToLastElements = (elements, className) => {
  elements.forEach((element) => {
    addClassToElement(element.lastElementChild, className);
  });
};

const removeClassFromLastElements = (elements, className) => {
  elements.forEach((element) => {
    removeClassFromElement(element.lastElementChild, className);
  });
};

export const initHeader = () => {
  const header = document.querySelector('.header');
  const sidebars = document.querySelectorAll('aside');
  const socials = document.querySelector('.post-content__socials');
  const postContent = document.querySelector('.post-content');

  if (!header) {
    return;
  }

  const hidePos = 0; // in px;
  const hideHeaderBottom = 126; // in px
  let prevScrollYPos = 0; // in px;

  const headerScrollHandler = () => {
    if (window.scrollY === 0) {
      removeClassFromElement(header, ['hide', 'scrolled']);
      removeClassFromLastElements(sidebars, 'last-elem--header-top-hover');
    } else if (window.scrollY > hidePos) {
      if (window.scrollY < prevScrollYPos) {
        removeClassFromElement(header, 'hide');
        addClassToLastElements(sidebars, 'last-elem--header-top-hover');
      } else {
        addClassToElement(header, 'hide');
        removeClassFromLastElements(sidebars, 'last-elem--header-top-hover');
      }
    }

    if (window.scrollY > hideHeaderBottom) {
      addClassToElement(header, 'scrolled');
    }

    prevScrollYPos = window.scrollY;
    if (postContent) {
      if (!header.classList.contains('hide')) {
        addClassToElement(socials, 'post-content__socials--header-top-hover');
      } else {
        removeClassFromElement(socials, 'post-content__socials--header-top-hover');
      }
    }
  };

  if (header.querySelector('.header__bottom')) {
    header.addEventListener('mouseenter', () => {
      addClassToLastElements(sidebars, 'last-elem--header-bottom-hover');
      if (postContent) {
        addClassToElement(socials, 'post-content__socials--header-bottom-hover');
      }
    });

    header.addEventListener('mouseleave', () => {
      removeClassFromLastElements(sidebars, 'last-elem--header-bottom-hover');
      if (postContent) {
        removeClassFromElement(socials, 'post-content__socials--header-bottom-hover');
      }
    });
  }

  headerScrollHandler();
  window.addEventListener('scroll', headerScrollHandler);
};
